import { useContactInfo } from './useContactInfo'

export const useAppQR = () => {
  const { data, ...rest } = useContactInfo()

  return {
    data: data?.mobileAppsLinks,
    ...rest
  }
}
